import { Observable, throwError as observableThrowError } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';
import { Error } from '@sb-tools/typescript/enums/error.enum';
import { TranslateService } from '@ngx-translate/core';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private commonDataService: CommonDataService,
        private notificationsService: NotificationsService,
        private translateService: TranslateService,
        private router: Router,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((response) => {
                return this.handleError(response, req);
            }),
        );
    }

    private handleError(response, req) {
        if (this.authenticationService.isLoggingOut) {
            return observableThrowError(response);
        }

        if (this.isRequestToToken(req.url)) {
            this.authenticationService.refreshPromise = null;
        }

        if (!response.error) {
            response.error = {};
        }

        let message;
        if (response.status === 400 && this.isRequestToToken(req.url)) {
            if (response.error.errorId === Error.sessionExpired) {
                this.authenticationService.logOff({ isNeedRedirect: true });
                return observableThrowError(response);
            }

            if (response.error.errorId === Error.communityWithNameNotFound) {
                this.authenticationService.redirectToCommunities();
                return observableThrowError(response);
            }

            message = response.error['message'] || response.error['error_description'];
            if (message) {
                this.notificationsService.error(this.translateService.instant('Error!'), message);
            }

            this.authenticationService.logOff({ isNeedRedirect: true });
        } else if (response.status === 401) {
            this.authenticationService.needToRefreshToken = true;
        } else if (
            response.error?.errorId === Error.communityWithNameNotFound ||
            (this.isRequestToToken(req.url) && response.status === 404)
        ) {
            this.router.navigate(['404'], {
                skipLocationChange: true,
            });
        } else if (
            response.error?.errorId === Error.thisResourceIsNotAvailableInYourCountry ||
            response.error?.errorId === Error.yourClientIpAddressDoesNotHaveAccessToThisResource
        ) {
            this.router.navigate(['403'], {
                skipLocationChange: true,
            });
        } else {
            if (response.error && (typeof response.error === 'string' || response.error.message)) {
                message = response.error && response.error.message ? response.error.message : response.error;
            } else {
                message = this.translateService.instant(
                    'Oops... Something went wrong, please try again or reload this page',
                );
            }

            this.notificationsService.error(this.translateService.instant('Error!'), message);
        }

        return observableThrowError(response);
    }

    // todo: add api url to cpmpare the whole address from the first char
    private isRequestToToken(url: string): boolean {
        return url.includes('oauth/token');
    }
}
